export default __webpack_public_path__ + "static/media/ubi-connect-logo.2046202f.svg";